import React from 'react'

const HamburgerIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M0 4h32v2.667h-32v-2.667zM0 25.333h32v2.667h-32v-2.667zM8 14.667h24v2.667h-24v-2.667z"/></svg>
)

export default HamburgerIcon